import React from 'react';

const Team = () => {
  const boardData = [
    {
      name: 'Edward Mwaka Oola',
      role: 'Chairperson',
      image: '/images/edward.jpeg',
    },
    {
      name: 'Dr. Anita Muhaire',
      role: 'Vice Chairperson',
      image: '/images/anita.jpeg',
    },
    {
      name: 'Liven Nagawa',
      role: 'Company Treasurer',
      image: '/images/liven.jpeg',
    },
    {
      name: 'David B. Mayanja Kizza',
      role: 'Company Secretary',
      image: '/images/david.jpeg',
    },
  ];

  const seniorData = [
    {
      name: 'Eunice Acan',
      role: 'Executive Director',
      image: '/images/eunice.jpeg',
    },
    {
      name: 'Herbert Mutegeki',
      role: 'Director of Programs',
      image: '/images/herbert.jpeg',
    },
  ];

  const managersData = [
    {
      name: 'Akol Angela',
      role: 'Partnerships & Resource Mobilization',
      image: '/images/AKOL-07.jpeg',
    },
    {
      name: 'Namara Kezia',
      role: 'Programs Manager',
      image: '/images/kazia.jpeg',
    },
    {
      name: 'Toolit Ambrose',
      role: 'MEL Officer',
      image: '/images/ambrosse.jpeg',
    },
  ];

  return (
    <div className="animate-in fade-in duration-1000 bg-[#f4f3f0]">

      {/* Hero Section */}
      <section className="relative pt-40 pb-24 px-4 bg-white overflow-hidden border-b border-brandBeige/50">
        <div className="absolute top-0 right-0 w-1/2 h-full bg-[#f4f3f0] skew-x-[-15deg] translate-x-32 hidden lg:block"></div>

        <div className="max-w-7xl mx-auto relative z-10">
          <div className="max-w-3xl">
            <h1 className="text-5xl md:text-6xl font-black text-brandBlack mb-6">
              Leadership & Team
            </h1>

            <p className="text-lg text-brandBlack/60 leading-relaxed font-medium max-w-2xl">
              Eunikare International is led by a dedicated team of professionals
              committed to social transformation and community excellence.
            </p>
          </div>
        </div>
      </section>

      <div className="py-24 space-y-32">

        {/* Board of Directors */}
        <section className="max-w-7xl mx-auto px-4 relative">
          <div className="absolute top-6 left-0 w-full h-[1px] bg-brandBeige/40 -z-10"></div>

          <div className="flex justify-center mb-16">
            <div className="bg-white border border-brandBeige px-8 py-3 rounded-full shadow-sm">
              <span className="text-[13px] font-black text-[#1b9a55] tracking-[0.2em] uppercase">
                Board of Directors
              </span>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-8">
            {boardData.map((member, index) => (
              <TeamCard
                key={index}
                name={member.name}
                role={member.role}
                img={member.image}
              />
            ))}
          </div>
        </section>

        {/* Senior Management */}
        <section className="max-w-7xl mx-auto px-4 relative">
          <div className="absolute top-6 left-0 w-full h-[1px] bg-brandBeige/40 -z-10"></div>

          <div className="flex justify-center mb-16">
            <div className="bg-white border border-brandBeige px-8 py-3 rounded-full shadow-sm">
              <span className="text-[13px] font-black text-[#1b9a55] tracking-[0.2em] uppercase">
                Senior Management Team
              </span>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-8">
            {seniorData.map((member, index) => (
              <TeamCard
                key={index}
                name={member.name}
                role={member.role}
                img={member.image}
              />
            ))}
          </div>
        </section>

        {/* Program Managers */}
        <section className="max-w-7xl mx-auto px-4 relative">
          <div className="absolute top-6 left-0 w-full h-[1px] bg-brandBeige/40 -z-10"></div>

          <div className="flex justify-center mb-16">
            <div className="bg-white border border-brandBeige px-8 py-3 rounded-full shadow-sm">
              <span className="text-[13px] font-black text-[#1b9a55] tracking-[0.2em] uppercase">
                Initiative Program Managers
              </span>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-8">
            {managersData.map((member, index) => (
              <TeamCard
                key={index}
                name={member.name}
                role={member.role}
                img={member.image}
              />
            ))}
          </div>
        </section>

      </div>

      {/* CTA */}
      <section className="pb-32 px-4">
        <div className="max-w-4xl mx-auto bg-[#1b9a55] rounded-[3rem] py-16 px-8 text-center text-white">
          <h2 className="text-3xl font-black mb-4">
            Interested in joining our team?
          </h2>

          <p className="text-white/90 text-sm max-w-2xl mx-auto font-medium leading-relaxed mb-8">
            We are always looking for passionate individuals to volunteer as
            Program Directors or join our management team.
          </p>

          <button className="bg-black text-white px-8 py-4 rounded-full font-bold text-sm hover:bg-black/80 transition-colors">
            View Open Positions
          </button>
        </div>
      </section>

    </div>
  );
};

const TeamCard = ({ name, role, img }) => {
  return (
    <div className="w-full max-w-[340px] sm:w-[280px] md:w-[320px] bg-white p-6 rounded-[2.5rem] border border-brandBeige/50 shadow-sm hover:shadow-xl transition-all duration-500 group">

      <div className="aspect-square overflow-hidden rounded-[2rem] mb-8 bg-brandBeige">
        <img
          src={img}
          alt={name}
          className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-1000 group-hover:scale-110"
          onError={(e) => {
            e.currentTarget.src = '/images/default-team.jpg';
          }}
        />
      </div>

      <div className="space-y-2 text-center">
        <h3 className="text-xl font-black text-brandBlack group-hover:text-brandGreen transition-colors">
          {name}
        </h3>

        <p className="text-[10px] font-bold text-brandBlack/40 uppercase tracking-widest">
          {role}
        </p>
      </div>

    </div>
  );
};

export default Team;